import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export const PUBLIC_PAGE_GUTTER_CLASSES = "px-4 sm:px-6 lg:px-8";

export const PUBLIC_PAGE_SHELL_CLASSES = `mx-auto w-full max-w-shell ${PUBLIC_PAGE_GUTTER_CLASSES}`;

export function AdminPageFrame({ children }: { children: ReactNode }) {
  return (
    <main
      id="main-content"
      className="flex min-h-0 min-w-0 flex-1 overflow-x-hidden overflow-y-auto px-(--page-gutter-x) py-(--page-gutter-y) [--page-gutter-x:1rem] [--page-gutter-y:0.75rem] md:has-[[data-page-fill]]:overflow-hidden has-[[data-record-sheet]]:bg-card xl:[--page-gutter-x:1.5rem]"
    >
      <div className="w-full min-w-0 has-[[data-page-fill]]:flex has-[[data-page-fill]]:h-full has-[[data-page-fill]]:flex-col">
        {children}
      </div>
    </main>
  );
}

export function DashboardPageFrame({
  before,
  children,
}: {
  before?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div
      id="main-content"
      className="flex min-h-0 min-w-0 flex-1 flex-col overflow-x-hidden overflow-y-auto px-(--page-gutter-x) py-(--page-gutter-y) [--page-gutter-x:0.75rem] [--page-gutter-y:0.75rem] md:has-[[data-page-fill]]:overflow-hidden sm:[--page-gutter-x:1rem] sm:[--page-gutter-y:1rem] lg:[--page-gutter-x:1.5rem] lg:[--page-gutter-y:1.5rem]"
    >
      {before}
      <div className="flex w-full min-w-0 flex-1 flex-col has-[[data-page-fill]]:min-h-0">
        {children}
      </div>
    </div>
  );
}

export function PublicPage({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      data-slot="public-page"
      className={cn(
        "mx-auto w-full max-w-[1440px] space-y-6 py-6",
        PUBLIC_PAGE_GUTTER_CLASSES,
        className,
      )}
    >
      {children}
    </div>
  );
}
